export const infoboxnames = {
  state: {
    currentItem: 'currentItem'
  },
  mutations: {
    SET_CURRENT_ITEM: 'SET_CURRENT_ITEM',
    CANCEL_CURRENT_ITEM: 'CANCEL_CURRENT_ITEM'
  },
  actions: {
    setCurrentItem: 'setCurrentItem',
    cancelCurrentItem: 'cancelCurrentItem'
  },
  getters: {
    visible: 'visible',
    currentItem: 'currentItem',
    hasCurrentItem: 'hasCurrentItem'
  }
}

export default infoboxnames
